//
//
//
//
//
//

export default {
	name: 'Loader'
}
